module.exports = __webpack_public_path__ + "img/DSC_7075.c8e05f4a.jpg";